module.exports = __webpack_public_path__ + "static/agatawork7-f1e3ed9da028dc5e2285d9578bc9e1c1.jpg";